import axios from "axios";
import { SET_USER_DATA } from "../../constants/ActionTypes";
import api from "../../constants/config";
import { isDayFirstLoginOfferPending } from "../../common";

function normalizeSubscriptions(userdataRow) {
  const legacy = userdataRow?.subscription && typeof userdataRow.subscription === "object"
    ? userdataRow.subscription
    : null;

  const array = Array.isArray(userdataRow?.subscriptions)
    ? userdataRow.subscriptions.filter((s) => s && typeof s === "object")
    : null;

  // Prefer the new array shape if present (even if legacy also exists).
  const normalizedArray = array && array.length > 0 ? array : (legacy ? [legacy] : []);

  const now = new Date();
  const parsed = normalizedArray.map((s) => {
    const exp = s.expirationDate ? new Date(s.expirationDate) : null;
    const purchased = s.purchasedDate ? new Date(s.purchasedDate) : null;
    const expTime = exp && !Number.isNaN(exp.getTime()) ? exp.getTime() : null;
    const purchasedTime =
      purchased && !Number.isNaN(purchased.getTime()) ? purchased.getTime() : null;
    const isCancelled = Boolean(s.isCancelled);
    const isSubscription = Boolean(s.isSubscription);
    const isActiveByExpiry = expTime ? expTime > now.getTime() : Boolean(isSubscription);
    const isActive = isSubscription && !isCancelled && isActiveByExpiry;

    return { raw: s, expTime, purchasedTime, isActive, isCancelled, isSubscription };
  });

  // Pick "current" subscription for legacy screens:
  // - prefer active subscriptions
  // - then prefer farthest expirationDate
  // - then newest purchasedDate
  const best = parsed
    .sort((a, b) => {
      if (a.isActive !== b.isActive) return a.isActive ? -1 : 1;
      const aExp = a.expTime ?? -1;
      const bExp = b.expTime ?? -1;
      if (aExp !== bExp) return bExp - aExp;
      const aPur = a.purchasedTime ?? -1;
      const bPur = b.purchasedTime ?? -1;
      return bPur - aPur;
    })[0];

  return {
    subscriptions: normalizedArray,
    subscription: best ? best.raw : null,
  };
}

export function setUserData(content) {
  return {
    type: SET_USER_DATA,
    content,
  };
}

export function updateUserData(obj) {
  return (dispatch) => {
    dispatch(setUserData(obj));
  };
}


export function getQuestionList() {
  return (dispatch, getState) => {
    const { user } = getState();

    if (
      localStorage.getItem("userKey") === "" &&
      localStorage.getItem("assesmentKey") === ""
    ) {
      return;
    }

    dispatch(setUserData({ questionError: "", isLoading: true }));

    api.post("question", {
      userId: localStorage.getItem("userKey"),
      surveyId: localStorage.getItem("assesmentKey"),
    })
      .then((res) => {
        if (res.status === 200) {
          let countDeterminArray = [];
          const prevDetermine = user.totalDetermine || [];

          res.data.forEach((obj) => {
            const alreadyAdded = countDeterminArray.find(
              (d) => d.name === obj.Determinant
            );
            if (!alreadyAdded) {
              const matchPrev = prevDetermine.find(
                (prev) => prev.name === obj.Determinant
              );
              countDeterminArray.push({
                name: obj.Determinant,
                isFillUp: matchPrev ? matchPrev.isFillUp : false,
              });
            }
          });

          dispatch(
            setUserData({
              questionList: res.data,
              totalDetermine: countDeterminArray,
              isNewUser: false,
              isLoading: false
            })
          );
        }
      })
      .catch((err) => {
        dispatch(
          setUserData({
            questionError: "Some Error Please refresh page or check Data",
            isLoading: false
          })
        );
      });
  };
}


export function signUpUser(object) {
  return (dispatch) => {
    localStorage.removeItem("progressDone");
    localStorage.removeItem("detailDone");
    dispatch(setUserData({ registrationError: "", isLoading: true }));
    let bodyData = {
      firstName: object.firstName,
      lastName: object.lastName,
      emailaddress: object.emailaddress,
      mobileNumber: object.mobileNumber,
      countryCode: object.countryCode,
      hostName: object.hostName,
      // marketingInfo: object.marketingInfo,
    };
    const couponCode = localStorage.getItem("couponCode");
    let url = "register";

    if (couponCode) {
      url += `?couponCode=${couponCode}`;
    }
    api.post(url, bodyData)
      .then((res) => {
        if (res.status === 200) {
          const tempObj = {
            hash: res.data.hash,
          };
          dispatch(
            setUserData({ ...tempObj, status: "otp", isLoading: false })
          );
        } else {
          dispatch(
            setUserData({
              registrationError: res.data.message,
              isLoading: false,
            })
          );
        }
      })
      .catch((err) => {
        dispatch(
          setUserData({
            registrationError: "Some Error Please refresh page or check Data",
            isLoading: false,
          })
        );
      });
  };
}

export function updateUser(object, openModal) {
  return (dispatch) => {
    dispatch(setUserData({ profileError: "", isLoading: true }));
    api.post("profile", object)
      .then((res) => {
        if (res.status === 200) {
          dispatch(setUserData({ ...res.data, isLoading: false }));
          if (openModal) {
            openModal();
          }
        } else {
          dispatch(
            setUserData({ profileError: res.data.message, isLoading: false })
          );
        }
      })
      .catch((err) => {
        dispatch(
          setUserData({
            profileError: "Some Error Please refresh page or check Data",
            isLoading: false,
          })
        );
      });
  };
}

export function updateQuestionAnswer(object) {
  return (dispatch, getState) => {
    dispatch(setUserData({ answeredData: "" }));
    api.post("question/userdatasave", object)
      .then((res) => {
        if (res.status === 200) {
          let { user } = getState();
          dispatch(
            setUserData({
              answeredData: user.answeredData ? user.answeredData + 1 : 1,
            })
          );
        } else {
          dispatch(setUserData({ questionError: res.data.message }));
        }
      })
      .catch((err) => {
        dispatch(
          setUserData({
            questionError: "Some Error Please refresh page or check Data",
          })
        );
      });
  };
}

export function loginUser(object) {
  return (dispatch) => {
    dispatch(setUserData({ loginError: "", isLoading: true }));
    api.post("login", object)
      .then((res) => {
        if (res.status === 200) {
          const tempObj = {
            hash: res.data.hash,
          };
          dispatch(
            setUserData({ ...tempObj, /* status: 'otp', */ isLoading: false })
          );
        } else {
          dispatch(
            setUserData({ loginError: res.data?.message, isLoading: false })
          );
        }
      })
      .catch((err) => {
        dispatch(
          setUserData({
            loginError: err?.message || "Something went wrong",
            isLoading: false,
          })
        );
      });
  };
}

/** Resend OTP using existing login/register APIs (no duplicate OTP generation). */
export function resendOtp({ isLogin, payload }) {
  return (dispatch) => {
    dispatch(setUserData({ otpError: "", isLoading: true }));

    const request = isLogin
      ? api.post("login", payload)
      : api.post(
          (() => {
            const couponCode = localStorage.getItem("couponCode");
            return couponCode ? `register?couponCode=${couponCode}` : "register";
          })(),
          payload
        );

    return request
      .then((res) => {
        if (res.status === 200 && res.data?.hash) {
          dispatch(setUserData({ hash: res.data.hash, otp: "", isLoading: false }));
          return res.data.hash;
        }
        const message =
          res.data?.message || "Unable to resend OTP. Please try again.";
        dispatch(setUserData({ otpError: message, isLoading: false }));
        return Promise.reject(new Error(message));
      })
      .catch((err) => {
        const message =
          err?.response?.data?.message ||
          err?.message ||
          "Unable to resend OTP. Please try again.";
        dispatch(
          setUserData({
            otpError: message,
            isLoading: false,
          })
        );
        return Promise.reject(new Error(message));
      });
  };
}

export function verifyOTP(object, navigate) {
  return (dispatch) => {
    dispatch(setUserData({ otpError: "", isLoading: true }));
    api.post("verifyOtp", object)
      .then((res) => {
        if (res.status === 200) {
          if (res.data[0]) {
            localStorage.setItem("userKey", res.data[0].UserID);
            localStorage.setItem("assesmentKey", res.data[0].SurveyId);
            localStorage.setItem("fingerprint", res.data[0].fingerprint);
            let demo = {
              firstName: res.data[0].Fname,
              lastName: res.data[0].Lname,
              hostName: res.data[0].source,
              emailaddress: res.data[0].EmailID,
              // marketingInfo: res.data[0].marketingInfo,
              mobileNumber: res.data[0].MobileNo,
              countryCode: res.data[0].CountryCode,
              height: res.data[0].Height,
              heightunit: res.data[0].HeightUnit
                ? res.data[0].HeightUnit
                : "Inches",
              weight: res.data[0].Weight,
              weightunit: res.data[0].WeightUnit
                ? res.data[0].WeightUnit
                : "Pounds",
              zipCode: res.data[0].ZipCode,
              age: res.data[0].Age,
              gender: res.data[0].Gender,
              _id: res.data[0].UserID,
              surveyId: res.data[0].SurveyId,
              signupForm: {
                firstName: "",
                lastName: "",
                emailaddress: "",
                mobileNumber: "",
                countryCode: "+1",
                hostName: "",
                // marketingInfo: ''
              },
              loginForm: {
                emailaddress: "",
                countryCode: "+1",
                mobileNumber: "",
              },
              otpSuccess: true,
              isLoading: false,
              dayFirstLogin: res.data[0].dayFirstLogin,
              isLoggedinModal: isDayFirstLoginOfferPending(res.data[0].dayFirstLogin),
            };
            dispatch(setUserData(demo));

            if (res.data[0].isSurveyCompleted === 1) {
              localStorage.setItem("progressDone", true);
            }

            if (
              demo.height &&
              demo.weight &&
              demo.zipCode &&
              demo.age &&
              demo.gender
            ) {
              localStorage.setItem("detailDone", true);
            }

            if (localStorage.getItem("progressDone") === null) {
              navigate(`/progress`);
            } else if (localStorage.getItem("detailDone") === null) {
              navigate("/profiledetail");
            } else {
              navigate(`/result`);
            }
          }
        } else {
          dispatch(
            setUserData({ otpError: res.data.message, isLoading: false })
          );
        }
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          dispatch(
            setUserData({
              otpError: err.response.data.message,
              isLoading: false,
            })
          );
        } else {
          dispatch(
            setUserData({
              otpError: err?.message || "Some Error Please refresh page or check Data",
              isLoading: false,
            })
          );
        }
      });
  };
}

export function getUserData(userKey, navigate, pathname) {
  return (dispatch) => {
    dispatch(setUserData({ userData: "", isLoading: true }));
    return api.post("userdata", { id: userKey })
      .then((res) => {
        if (res.status === 200) {
          if (res.data[0]) {
            localStorage.setItem("userKey", res.data[0].UserID);
            const { subscriptions, subscription } = normalizeSubscriptions(res.data[0]);
            const dayFirstLogin = res.data[0].dayFirstLogin;
            let demo = {
              firstName: res.data[0].Fname,
              lastName: res.data[0].Lname,
              emailaddress: res.data[0].EmailID,
              mobileNumber: res.data[0].MobileNo,
              countryCode: res.data[0].CountryCode,
              hostName: res.data[0].source,
              // marketingInfo: res.data[0].marketingInfo,
              height: res.data[0].Height,
              heightunit: res.data[0].HeightUnit
                ? res.data[0].HeightUnit
                : "Inches",
              weight: res.data[0].Weight,
              weightunit: res.data[0].WeightUnit
                ? res.data[0].WeightUnit
                : "Pounds",
              zipCode: res.data[0].ZipCode,
              age: res.data[0].Age,
              gender: res.data[0].Gender,
              _id: res.data[0].UserID,
              // New shape (primary source of truth)
              subscriptions,
              // Legacy shape (kept for older UI paths)
              subscription,
              programPurchased: res.data[0].programPurchased,
              customerId: res.data[0].customerId,
              shopUrl: res.data[0].shopUrl,
              recipeUrl: res.data[0].recipeUrl,
              communityUrl: res.data[0].communityUrl,
              eventUrl: res.data[0].eventUrl,
              searchUrl: res.data[0].searchUrl,
              bookConsultUrl: res.data[0].bookConsultUrl,
              membershipFeatures: Array.isArray(res.data[0].membershipFeatures)
                ? res.data[0].membershipFeatures
                : [],
              accountLoaded: true,
              ...(isDayFirstLoginOfferPending(dayFirstLogin)
                ? { isLoggedinModal: true }
                : dayFirstLogin === true || dayFirstLogin === 1 || dayFirstLogin === "1"
                  ? { isLoggedinModal: false }
                  : {}),
            };

            // if (res.data[0].isSurveyCompleted === '1') {
            // 	localStorage.setItem('progressDone', true)
            // }

            // if (
            //   demo.height &&
            //   demo.weight &&
            //   demo.zipCode &&
            //   demo.age &&
            //   demo.gender
            // ) {
            //   localStorage.setItem("detailDone", true);
            // }

            dispatch(setUserData(demo));

            if (navigate) {
              if (pathname && pathname !== "/result") {
                navigate(pathname);
              } else if (
                localStorage.getItem("progressDone") == null
              ) {
                navigate(`/progress`);
              } else if (
                localStorage.getItem("detailDone") == null
              ) {
                navigate("/profiledetail");
              } else {
                navigate(`/result`);
              }
            }

            return getPaymentHistoryListApi()
              .then((phRes) => {
                const list = phRes?.data?.data;
                dispatch(
                  setUserData({
                    paymentHistoryList: Array.isArray(list) ? list : [],
                    isLoading: false,
                  })
                );
              })
              .catch(() => {
                dispatch(
                  setUserData({
                    paymentHistoryList: [],
                    isLoading: false,
                  })
                );
              })
              .then(() => ({ ...demo, rawResponse: res }));
          }
        } else {
          dispatch(
            setUserData({ userData: res.data.message, isLoading: false })
          );
        }
        return res;
      })
      .catch((err) => {
        dispatch(
          setUserData({
            userData: "Some Error Please refresh page or check Data",
            isLoading: false,
            accountLoaded: true,
          })
        );
      });
  };
}

export function getDeterminants() {
  return (dispatch) => {
    dispatch(
      setUserData({
        isLoading: true,
      })
    );
    return api.post("userscore", {
      userId: localStorage.getItem("userKey"),
      surveyId: localStorage.getItem("assesmentKey"),
    })
      .then((res) => {
        if (res.status === 200) {
          dispatch(getSurveyList());
          dispatch(
            setUserData({
              determinantList: res.data.data,
              userFinalScore: res.data.finalScore,
              isLoading: false,
            })
          );
          return res?.data?.data
        }
      })
      .catch((err) => {
        dispatch(
          setUserData({
            isLoading: false,
          })
        );
      });
  };
}

export function updateSuggestion(userId, suggestionId) {
  return (dispatch) => {
    api.post("updateSuggestionDate", {
      userId: userId,
      SuggestionID: suggestionId,
    })
      .then((res) => { })
      .catch((err) => {
      });
  };
}

export function updateReference(userId, suggestionId) {
  return (dispatch) => {
    api.post("updateReferenceDate", {
      userId: userId,
      SuggestionID: suggestionId,
    })
      .then((res) => { })
      .catch((err) => {
      });
  };
}

export function deleteUserResponse(userId, surveyId, navigate) {
  return (dispatch) => {
    dispatch(
      setUserData({
        isLoading: true,
      })
    );
    api.post("question/deletedatasave", {
      userId: userId,
      surveyId: surveyId,
    })
      .then((res) => {
        if (res.status === 200) {
          localStorage.removeItem("progressDone");
          localStorage.removeItem("detailDone");
          dispatch(
            setUserData({
              questionList: [],
              totalDetermine: [],
              determinantList: [],
              height: "",
              heightunit: "Inches",
              weight: "",
              weightunit: "Pounds",
              zipCode: "",
              age: "",
              gender: "",
              isLoading: false,
              otpSuccess: false,
              userFinalScore: 0,
              isNewUser: false,
            })
          );
          navigate(`/progress`);
        }
      })
      .catch((err) => {
        dispatch(
          setUserData({
            isLoading: false,
          })
        );
      });
  };
}

export function newTest(userId, navigate) {
  return (dispatch) => {
    dispatch(
      setUserData({
        isLoading: true,
      })
    );
    api.post("/newsurvey", { userId: localStorage.getItem("userKey") })
      .then((res) => {
        if (res.status === 200) {
          localStorage.removeItem("progressDone");
          localStorage.removeItem("detailDone");
          localStorage.setItem("assesmentKey", res.data.surveyId);
          dispatch(
            setUserData({
              questionList: [],
              totalDetermine: [],
              determinantList: [],
              isLoading: false,
              userFinalScore: 0,
              isNewUser: false,
              surveyId: res.data.surveyId,
            })
          );
          navigate(`/progress`);
        }
      })
      .catch((err) => {
        dispatch(
          setUserData({
            isLoading: false,
          })
        );
      });
  };
}

export function getSurveyList() {
  return (dispatch) => {
    dispatch(setUserData({ isLoading: true }));
    return api.post("surveyIdList", {
      userId: localStorage.getItem("userKey"),
    })
      .then((res) => {
        if (res.status === 200) {
          dispatch(
            setUserData({
              ...res.data,
              surveyIdList: res.data.surveyIdList,
              isLoading: false,
            })
          );
          return res.data.surveyIdList
        } else {
          dispatch(setUserData({ isLoading: false }));
        }
      })
      .catch((err) => {
        dispatch(setUserData({ isLoading: false }));
      });
  };
}


export const paymentCheckoutURLApi = async (data) => {
  const res = await api.post("create-pay-checkout", data)
  return res
}

export const getProgramListApi = async () => {
  const couponCode = localStorage.getItem('couponCode') || '';
  const res = await api.get(`get-program-subscription-list-user?couponCode=${couponCode}`, {
    headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' },
    params: { _: Date.now() },
  })
  return res
}

export const getPaymentHistoryListApi = async () => {
  const res = await api.get("getUsersOrder")
  return res
}


export function initiateGoals(data) {
  return async (dispatch) => {
    dispatch(setUserData({ isLoading: true }));
    try {
      const res = await api.post("save-goals", data);
      if (res.status === 200) {
        dispatch(
          setUserData({
            ...res.data,
            isLoading: false,
          })
        );
      } else {
        dispatch(setUserData({ isLoading: false }));
      }
      return res.status;
    } catch (err) {
      dispatch(
        setUserData({
          isLoading: false,
          error: { errormsg: err.response.data.message },
        })
      );
      return err.response.status;
    }
  };
}

export function withdrawGoals(data) {
  return async (dispatch) => {
    dispatch(setUserData({ isLoading: true }));
    try {
      const res = await api.post("withdraw-goal", data);
      if (res.status === 200) {
        dispatch(
          setUserData({
            ...res.data,
            isLoading: false,
          })
        );
      } else {
        dispatch(setUserData({ isLoading: false }));
      }
      return res.status;
    } catch (err) {
      dispatch(
        setUserData({
          isLoading: false,
          error: { errormsg: err.response.data.message },
        })
      );
      return err.response.status;
    }
  };
}

export function getFeedbackQuestionList() {
  return (dispatch) => {
    dispatch(
      setUserData({
        isLoading: true,
      })
    );
    api.get("feedback-questions")
      .then((res) => {
        if (res.status === 200) {
          const response = res?.data?.data || [];
          if (response) {
            dispatch(
              setUserData({
                feedbackQuestionList: response,
                isLoading: false,
              })
            );
          }
        }
      })
      .catch((err) => {
        dispatch(
          setUserData({
            isLoading: false,
            error: { errormsg: err.message },
          })
        );
      });
  };
}

export function updateFeedback(data) {
  return (dispatch) => {
    dispatch(setUserData({ isLoading: true }));
    api.post("submit-feedback", data)
      .then((res) => {
        if (res.status === 200) {
          dispatch(
            setUserData({
              isLoading: false,
            })
          );
        } else {
          dispatch(setUserData({ isLoading: false }));
        }
      })
      .catch((err) => {
        dispatch(setUserData({ isLoading: false }));
      });
  };
}


export const getCoursesApi = async () => {
  const res = await api.get('getCourses', {
    headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' },
    params: { _: Date.now() },
  });
  return res?.data;
}

export const cancelSubscriptionApi = async (paymentHistoryId, isCancelling) => {
  const res = await api.get(`cancel_renew_subscription?historyId=${paymentHistoryId ? paymentHistoryId : null}&isCancelling=${isCancelling}`);
  return res;
}

export const sendInviteForLabsApi = async () => {
  const res = await api.post('sendInviteForLabs');
  return res;
}

export const getSiteSettingsApi = async () => {
  const res = await api.get("site-settings");
  return res?.data?.data || res?.data || {};
}

export const getActiveZohoLabFormConfigApi = async () => {
  const res = await api.get('zoho-lab-form-config/active-for-me');
  return res?.data;
}

export const unSubscribeUserApi = async (payload, token) => {
  const res = await api.post(`unsubscribeUser?token=${token}`, payload);
  return res;
}